import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=2198315c&scoped=true&"
var script = {}
import style0 from "./Legal.vue?vue&type=style&index=0&id=2198315c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2198315c",
  null
  
)

export default component.exports